module.exports = __webpack_public_path__ + "img/eh.04684006.svg";